import axios from 'axios';
import { envConfig } from '../../utils/enviroment';

export const uploadAPI = axios.create({
  baseURL: envConfig.REACT_APP_UPLOAD_BASE_URL_API,
  headers: { 'Content-type': 'application/json', callOrigin: 'external' }
});
